export const getDefaultState = () => {
  return {
    notifications: []
  }
}
